import { OVERLAY_VIEWPORT_Z_INDEX_CLASS } from "../../utils/constants.js";
import { tv } from "../../variants/tv.js";
const tooltipVariants = tv({
    slots: {
        baseSlot: 'relative w-auto rounded-xl px-3 py-2 text-body3 transition-all',
        containerSlot: 'flex flex-row items-center justify-between gap-1',
        contentSlot: 'flex flex-row items-center justify-center gap-1',
        iconSlot: '',
        arrowSlot: 'h-(--tooltip-arrow-size) w-(--tooltip-arrow-size) rotate-45 rounded-tl-[3px] [clip-path:polygon(0%_0%,0%_100%,100%_0%)]',
        arrowContainerSlot: 'data-[side=bottom]:top-(--tooltip-arrow-offset-y) data-[side=left]:right-[calc(var(--tooltip-arrow-offset-x)+1px)] data-[side=left]:rotate-90 data-[side=right]:left-(--tooltip-arrow-offset-x) data-[side=right]:-rotate-90 data-[side=top]:bottom-(--tooltip-arrow-offset-y) data-[side=top]:rotate-180',
        triggerSlot: '',
        positionerSlot: OVERLAY_VIEWPORT_Z_INDEX_CLASS
    },
    variants: {
        color: {
            neutral: {},
            success: {},
            error: {}
        },
        emphasis: {
            regular: {},
            bold: {}
        },
        showArrow: {
            true: {},
            false: {}
        },
        width: {
            '3xs': {
                baseSlot: 'w-64'
            },
            '2xs': {
                baseSlot: 'w-72'
            },
            xs: {
                baseSlot: 'w-80'
            },
            sm: {
                baseSlot: 'w-96'
            },
            md: {
                baseSlot: 'w-112'
            },
            lg: {
                baseSlot: 'w-128'
            },
            xl: {
                baseSlot: 'w-144'
            },
            '2xl': {
                baseSlot: 'w-168'
            },
            '3xl': {
                baseSlot: 'w-192'
            },
            '4xl': {
                baseSlot: 'w-224'
            },
            '5xl': {
                baseSlot: 'w-256'
            },
            '6xl': {
                baseSlot: 'w-288'
            },
            '7xl': {
                baseSlot: 'w-320'
            },
            auto: {
                baseSlot: 'w-auto'
            }
        }
    },
    defaultVariants: {
        emphasis: 'bold',
        showArrow: false
    },
    compoundSlots: [
        {
            slots: [
                'baseSlot'
            ],
            class: 'drop-shadow-lg'
        },
        {
            slots: [
                'arrowSlot'
            ],
            showArrow: false,
            class: 'invisible'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            class: 'bg-neutral-1'
        },
        {
            slots: [
                'baseSlot'
            ],
            color: 'neutral',
            class: 'text-neutral-11'
        },
        {
            slots: [
                'baseSlot'
            ],
            color: 'success',
            class: 'text-success-11'
        },
        {
            slots: [
                'baseSlot'
            ],
            color: 'error',
            class: 'text-error-11'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            color: 'neutral',
            class: 'bg-neutral-8 text-neutral-1'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            color: 'neutral',
            emphasis: 'regular',
            class: 'bg-neutral-1 text-neutral-11'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            color: 'success',
            class: 'bg-success-8 text-neutral-1'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            color: 'success',
            emphasis: 'regular',
            class: 'bg-success-1 text-success-11'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            color: 'error',
            class: 'bg-error-8 text-neutral-1'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            color: 'error',
            emphasis: 'regular',
            class: 'bg-error-1 text-error-11'
        },
        {
            slots: [
                'iconSlot'
            ],
            color: 'neutral',
            class: 'text-neutral-10'
        },
        {
            slots: [
                'iconSlot'
            ],
            color: 'success',
            class: 'text-success-7'
        },
        {
            slots: [
                'iconSlot'
            ],
            color: 'error',
            class: 'text-error-7'
        },
        {
            slots: [
                'baseSlot'
            ],
            class: 'transition-duration-extra-short transition-duration-snap motion-safe:data-[ending-style]:animate-fade-out-100-0 motion-safe:data-[starting-style]:animate-fade-in-0-100'
        }
    ]
});
const ValidTooltipColorValues = Object.keys(tooltipVariants.variants.color);
const ValidTooltipEmphasisValues = Object.keys(tooltipVariants.variants.emphasis);
export { ValidTooltipColorValues, ValidTooltipEmphasisValues, tooltipVariants };
